import {NgModule, Optional, SkipSelf} from "@angular/core";
import {HttpClient, provideHttpClient, withInterceptorsFromDi} from "@angular/common/http";
import {TranslateModule} from "@ngx-translate/core";
import {provideTranslateHttpLoader} from "@ngx-translate/http-loader";
import {FUINavigationLoader, UiModule} from "@fedelta-pos/ui";
import {NavigationLoader} from "../main/navigation-loader";
import {NotificationService} from "../notifications/notification.service";
import {ErrorHandlerService} from "../error-handler.service";
import {AuthApiService} from "../fonzie/auth/auth-api.service";


export function navigationLoaderFactory(httpClient: HttpClient): FUINavigationLoader {
    return new NavigationLoader(httpClient);
}

@NgModule({
    imports: [
        TranslateModule.forRoot({
            loader: provideTranslateHttpLoader({
                prefix: "/assets/i18n/",
                suffix: ".json"
            })
        }),
        UiModule.forRoot({
            providedLoader: {
                provide: FUINavigationLoader,
                useFactory: navigationLoaderFactory,
                deps: [HttpClient]
            }
        })
    ],
    providers: [
        provideHttpClient(withInterceptorsFromDi()),
        NotificationService,
        ErrorHandlerService,
        AuthApiService
    ]
})
export class CoreModule {
    constructor(@Optional() @SkipSelf() parentModule: CoreModule, errorHandlerService: ErrorHandlerService) {
        if (parentModule) {
            throw new Error("CoreModule is already loaded. Import it in the AppModule only");
        }
    }
}
